import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWall2Up: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-wall-2-up, align top"><path d="M7.75 9.5L12 5.25L16.25 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 3.75H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 20.25V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowWall2Up;
